import apiCall from './api';

export const stockService = {
  
  /**
   * Récupérer tout le stock de la boutique
   */
  getStock: async (params = {}) => {
    try {
      
      // Essayer d'abord l'endpoint stock principal
      try {
        const response = await apiCall.get('/manager/stock', params);
        if (response.success && response.data) {
          const stockData = Array.isArray(response.data) ? response.data : [];
          return { success: true, data: stockData };
        }
      } catch (stockError) {
      }
      
      // ✅ CORRECTION : Fallback sur les produits avec leurs stocks ET images
      const response = await apiCall.get('/manager/products', { 
        ...params, 
        includeStock: true,
        size: 1000 // Récupérer tous les produits
      });
      
      if (response.success) {
        
        let productsArray = [];
        
        if (Array.isArray(response.data)) {
          productsArray = response.data;
        } else if (response.data && Array.isArray(response.data.content)) {
          productsArray = response.data.content;
        } else if (response.data && Array.isArray(response.data.data)) {
          productsArray = response.data.data;
        } else {
          productsArray = [];
        }
        
        if (productsArray.length === 0) {
          return { success: true, data: [], message: 'Aucun produit trouvé' };
        }
        
        
        // ✅ CORRECTION : Transformer les produits en format stock AVEC imageUrl
        const stockData = productsArray.map(product => {
          
          
          return {
            id: product.id,
            productId: product.product_id || product.id,
            productName: product.product_name || product.name || 'Produit sans nom',
            productSku: product.product_sku || product.sku || '',
            categoryName: product.category_name || product.categoryName || product.category?.name || 'Non catégorisé',
            
            // ✅ AJOUT : Récupération de l'imageUrl avec tous les noms possibles
            imageUrl: product.imageUrl || product.image_url || product.image || null,
            image_url: product.imageUrl || product.image_url || product.image || null, // Alias
            image: product.imageUrl || product.image_url || product.image || null, // Alias
            
            quantity: product.quantity || product.currentStock || product.current_stock || 0,
            currentStock: product.quantity || product.currentStock || product.current_stock || 0,
            minThreshold: product.min_threshold || product.minThreshold || product.threshold || 5,
            maxThreshold: product.max_threshold || product.maxThreshold || 100,
            isLowStock: product.is_low_stock !== undefined ? product.is_low_stock : (product.isLowStock === true),
            isOutOfStock: product.is_out_of_stock !== undefined ? product.is_out_of_stock : (product.isOutOfStock === true),
            lastUpdated: product.last_updated || product.lastUpdated || product.updatedAt,
            unitCost: product.unit_cost || product.costPrice || product.purchasePrice || 0,
            sellPrice: product.sell_price || product.sellPrice || product.price || 0
          };
        });
        
        return { success: true, data: stockData };
      }
      
      return { success: false, data: [], message: 'Aucun stock trouvé' };
    } catch (error) {
      console.error('❌ Erreur lors de la récupération du stock:', error);
      return { success: false, data: [], message: 'Erreur de connexion' };
    }
  },

  /**
   * ✅ CORRIGÉ : Créer un mouvement de stock
   * Utilise le bon endpoint selon le type de mouvement
   */
  createStockMovement: async (movementData) => {
    try {
      
      const { productId, type, quantity, reason, unitCost, reference } = movementData;
      
      // Validation des données
      if (!productId || !type || (!quantity && quantity !== 0)) {
        throw new Error('Données manquantes : productId, type et quantity sont requis');
      }
      
      if (quantity <= 0) {
        throw new Error('La quantité doit être positive');
      }
      
      // ✅ CORRECTION : Utiliser différents endpoints selon le type
      if (type === 'AJUSTEMENT' || type === 'ADJUSTMENT') {
        // Pour les ajustements, utiliser l'endpoint /adjust
        
        const adjustmentData = {
          newQuantity: parseInt(quantity), // La nouvelle quantité totale
          reason: reason || `Ajustement à ${quantity}`,
          minThreshold: null,
          maxThreshold: null
        };
        
        
        const response = await apiCall.post(`/manager/stock/products/${productId}/adjust`, adjustmentData);
        
        if (response.success) {
          return response;
        }
        
        return { success: false, message: response.message || 'Erreur lors de l\'ajustement' };
      } else {
        // Pour les entrées et sorties, utiliser l'endpoint /movement
        
        const stockMovementRequest = {
          productId: productId,
          type: type.toUpperCase(), // ENTREE, SORTIE
          quantity: parseInt(quantity), // Quantité à ajouter/retirer
          reason: reason || `Mouvement ${type}`,
          reference: reference || null,
          unitCost: (type === 'ENTREE' && unitCost) ? parseFloat(unitCost) : null
        };
        
        
        const response = await apiCall.post('/manager/stock/movement', stockMovementRequest);
        
        if (response.success) {
          return response;
        }
        
        return { success: false, message: response.message || 'Erreur lors de la création du mouvement' };
      }
      
    } catch (error) {
      console.error('❌ Erreur lors de la création du mouvement:', error);
      return { success: false, message: error.message || 'Erreur de connexion' };
    }
  },

  /**
   * Récupérer les alertes de stock faible
   */
  getLowStockAlerts: async () => {
    try {
      
      try {
        const response = await apiCall.get('/manager/stock/alerts');
        if (response.success) {
          return response;
        }
      } catch (alertError) {
      }
      
      // Fallback : calculer les alertes à partir du stock
      const stockResponse = await stockService.getStock();
      if (stockResponse.success) {
        const lowStockItems = stockResponse.data.filter(item => item.isLowStock || item.isOutOfStock);
        return { success: true, data: lowStockItems };
      }
      
      return { success: false, data: [], message: 'Aucune alerte' };
    } catch (error) {
      console.error('❌ Erreur lors de la récupération des alertes:', error);
      return { success: false, data: [], message: 'Erreur de connexion' };
    }
  },

  /**
   * Récupérer l'historique des mouvements
   */
  getStockMovements: async (params = {}) => {
    try {
      
      try {
        const managerResponse = await apiCall.get('/manager/stock/movements', params);
        if (managerResponse.success) {
          return managerResponse;
        }
      } catch (managerError) {
      }
      
      try {
        const employeeResponse = await apiCall.get('/employee/stock/movements', params);
        if (employeeResponse.success) {
          return employeeResponse;
        }
      } catch (employeeError) {
      }
      
      return { 
        success: true, 
        data: [], 
        message: 'Fonctionnalité de suivi des mouvements en cours de développement' 
      };
      
    } catch (error) {
      console.error('❌ Erreur lors de la récupération des mouvements:', error);
      return { success: false, data: [], message: 'Erreur de connexion' };
    }
  },

  /**
   * ✅ NOUVEAU : Ajuster le stock (pour les seuils uniquement)
   * Utilise l'endpoint d'ajustement pour modifier les seuils
   */
  updateStockThreshold: async (productId, thresholdData) => {
  try {
    
    
    // ✅ CORRECTION PRINCIPALE : Respecter exactement le format de StockAdjustmentRequest
    const adjustmentData = {
      newQuantity: thresholdData.newQuantity, // ← OBLIGATOIRE dans le DTO
      minThreshold: thresholdData.minThreshold || thresholdData.threshold,
      maxThreshold: thresholdData.maxThreshold || null,
      reason: thresholdData.reason || 'Mise à jour des seuils d\'alerte'
    };
    
    
    // ✅ Validation côté client avant envoi
    if (adjustmentData.newQuantity === null || adjustmentData.newQuantity === undefined) {
      throw new Error('La quantité actuelle est requise pour la mise à jour des seuils');
    }
    
    if (adjustmentData.minThreshold < 0) {
      throw new Error('Le seuil minimum ne peut pas être négatif');
    }
    
    if (adjustmentData.maxThreshold !== null && adjustmentData.maxThreshold <= adjustmentData.minThreshold) {
      throw new Error('Le seuil maximum doit être supérieur au seuil minimum');
    }
    
    const response = await apiCall.post(`/manager/stock/products/${productId}/adjust`, adjustmentData);
    
    if (response.success) {
      return response;
    }
    
    return { 
      success: false, 
      message: response.message || 'Erreur lors de la mise à jour des seuils' 
    };
  } catch (error) {
    console.error('❌ Erreur lors de la mise à jour des seuils:', error);
    return { 
      success: false, 
      message: error.message || 'Erreur de connexion' 
    };
  }
},

  /**
   * Calculer les statistiques du stock
   */
  calculateStockStats: (stockItems) => {
    if (!Array.isArray(stockItems)) {
      return {
        totalProducts: 0,
        totalValue: 0,
        lowStockItems: 0,
        emptyStockItems: 0,
        averageStockLevel: 0
      };
    }
    
    let totalStock = 0;
    let lowStockCount = 0;
    let emptyStockCount = 0;
    let totalValue = 0;
    
    stockItems.forEach(item => {
      const currentStock = item.currentStock || item.quantity || 0;
      const minimumStock = item.minimumStock || item.threshold || item.minThreshold || 0;
      const unitCost = item.unitCost || item.costPrice || 0;
      
      totalStock += currentStock;
      totalValue += currentStock * unitCost;
      
      if (currentStock === 0) {
        emptyStockCount++;
      } else if (currentStock <= minimumStock) {
        lowStockCount++;
      }
    });
    
    return {
      totalProducts: stockItems.length,
      totalValue: totalValue,
      lowStockItems: lowStockCount,
      emptyStockItems: emptyStockCount,
      averageStockLevel: stockItems.length > 0 ? Math.round(totalStock / stockItems.length) : 0
    };
  },

  /**
   * Formater les données de stock pour l'affichage
   */
  formatStockForDisplay: (stock) => {
    if (!stock) return null;
    
    return {
      id: stock.id,
      productId: stock.product_id || stock.productId,
      productName: stock.product_name || stock.productName || stock.product?.name || 'Produit sans nom',
      currentStock: stock.quantity || stock.currentStock || 0,
      minimumStock: stock.min_threshold || stock.minimumStock || stock.threshold || stock.minThreshold || 0,
      maximumStock: stock.max_threshold || stock.maximumStock || stock.maxThreshold || null,
      unitCost: stock.unit_cost || stock.unitCost || stock.costPrice || 0,
      sellingPrice: stock.sell_price || stock.sellingPrice || stock.sellPrice || stock.product?.price || 0,
      totalValue: (stock.quantity || stock.currentStock || 0) * (stock.unit_cost || stock.unitCost || stock.costPrice || 0),
      lastMovement: stock.last_movement || stock.lastMovement,
      lastUpdate: stock.last_updated || stock.lastUpdate || stock.lastUpdated || stock.updatedAt,
      status: stockService.getStockStatus(
        stock.quantity || stock.currentStock || 0, 
        stock.min_threshold || stock.minimumStock || stock.threshold || stock.minThreshold || 0
      ),
      category: stock.category_name || stock.product?.category?.name || stock.categoryName || 'Non catégorisé'
    };
  },

  /**
   * Déterminer le statut du stock
   */
  getStockStatus: (currentStock, minimumStock) => {
    if (currentStock === 0) {
      return { level: 'empty', label: 'Rupture', color: 'danger' };
    } else if (currentStock <= minimumStock) {
      return { level: 'low', label: 'Stock faible', color: 'warning' };
    } else if (currentStock <= minimumStock * 2) {
      return { level: 'medium', label: 'Stock moyen', color: 'info' };
    } else {
      return { level: 'good', label: 'Stock OK', color: 'success' };
    }
  },

  /**
   * Types de mouvements de stock
   */
  getMovementTypes: () => {
    return [
      { value: 'ENTREE', label: 'Entrée', icon: '📥', color: 'success' },
      { value: 'SORTIE', label: 'Sortie', icon: '📤', color: 'warning' },
      { value: 'AJUSTEMENT', label: 'Ajustement', icon: '⚖️', color: 'info' }
    ];
  }
};

export default stockService;